import { useAuthentication } from '@src/features/auth';
import { useAPIClientBase } from '@src/shared/api';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

function useAPIClient() {
  const auth = useAuthentication();
  const navigate = useNavigate();

  const handle401 = useCallback(() => {
    navigate({ to: '/auth/login' });
  }, [navigate]);

  return useAPIClientBase({ auth, on401: handle401 });
}

export default useAPIClient;
